import { AttributeDataType, CustomAttributeType } from "@validereinc/domain";

/**
 * This function is used to sanitize custom attribute form values based on their definition.
 *
 * @param {Record<string, any>} values Custom attribute value object
 * @param {CustomAttributeType[]} customAttributes Definition of custom attributes of asset
 * @returns {Record<string, any>} Sanitized form values for custom attributes, ready to be sent to the API.
 */
export const sanitizeCustomAttributeFormInputs = (
  values: Record<string, any>,
  customAttributes: CustomAttributeType[]
): Record<string, any> => {
  return Object.keys({
    ...(values ?? {}),
  } as Record<string, string>).reduce(
    (
      newCustomAttributes: Record<string, string>,
      customAttributeKey: string
    ) => {
      const customAttributeDefinition = customAttributes.find(
        (ca) => ca.field_name === customAttributeKey
      );

      if (!customAttributeDefinition) {
        return newCustomAttributes;
      }

      switch (customAttributeDefinition?.data_type) {
        case AttributeDataType.PICK_LIST:
        case AttributeDataType.MULTI_PICK_LIST: {
          if (
            values?.[customAttributeKey] !== undefined &&
            values?.[customAttributeKey] !== null &&
            values?.[customAttributeKey] !== "" &&
            !(
              !customAttributeDefinition.is_required &&
              Array.isArray(values?.[customAttributeKey]) &&
              values?.[customAttributeKey].length === 0
            )
          ) {
            newCustomAttributes[customAttributeKey] =
              values[customAttributeKey];
          }
          break;
        }
        case AttributeDataType.FILE: {
          newCustomAttributes[customAttributeKey] =
            values[customAttributeKey]?.[0] ?? null;
          break;
        }
        default:
          newCustomAttributes[customAttributeKey] = values[customAttributeKey];
      }

      return newCustomAttributes;
    },
    {}
  );
};
